import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import { FormControl, Input, Typography } from "@mui/material";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {
  buyPackageApi, mellatPayApi
} from "../../../../../services/packagesApi";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../utils/utilsFunctions";
import Invoice from "./Invoice"
import Divider from '@mui/material/Divider';

export default function Pay(props) {
  const { referralCodeToken, discountCodeToken, selectedProduct, mobileNo } = props
  const [product, setproduct] = React.useState({
    productId: selectedProduct.productId || "",
    referralCodeToken: referralCodeToken.Token || "",
    discountCodeToken: discountCodeToken.codeToken || ""
  });
  const [infoBox, setInfoBox] = React.useState({ state: "Wait", msg: "" });
  const [backdrop, setBackdrop] = React.useState(false);
  const [orderId, setOrderId] = React.useState(false);
  const [refId, setRefId] = React.useState(false);
  const [invoiceContent, setInvoiceContent] = React.useState(false);

  const handleInfoBox = (data) => {
    setInfoBox(data)
  }

  // console.log("amir", product)

  const mellatGateway = async () => {
    try {
      setBackdrop(true)
      handleInfoBox({ state: "selectGateway", msg: "انتقال به درگاه" })
      let response = await mellatPayApi({ orderId, gateway: "mellatGateway", mobileNo })
      if (response["data"]["success"]) {
        setRefId(response["data"]["RefId"])
        setTimeout(() => {
          document.formBankMellat.submit();
        }, 500);
      } else {
        console.log("Error-mellatGateway")
      }
      setBackdrop(false)
    } catch (error) {
      setBackdrop(false)
      const errData = checkErrorMessage(error);

      // customToastify("error", errData["titles"] || errData["message"]);
      handleInfoBox({ state: "error", msg: errData["titles"] || errData["message"] })
      // console.error(error);
    }
  }

  const buyPackage = async () => {
    try {
      setBackdrop(true)
      let response = await buyPackageApi(product)
      const resData = checkResponseData(response);
      if (resData["success"]) {
        setInvoiceContent({ payedPrice: resData["data"]["payedPrice"], orderId: resData["data"]["orderId"], buyingDate: resData["data"]["buyingDate"], endingDate: resData["data"]["endingDate"] })
        setOrderId(resData["data"]["orderId"])
        handleInfoBox({ state: "sucess", msg: "لینک خرید" })
        setBackdrop(false)


      } else {
        customToastify("info", resData["message"]);
        setBackdrop(false)

      }
    } catch (error) {
      setBackdrop(false)
      const errData = checkErrorMessage(error);

      // customToastify("error", errData["titles"] || errData["message"]);
      handleInfoBox({ state: "error", msg: errData["titles"] || errData["message"] })
      // console.error(error);
    }
  }


  function showInfoBox() {
    switch (infoBox.state) {
      case "wait":
        return (
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={backdrop}
          // onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          // <Typography>
          //   wait
          // </Typography>
        );
      case "error":
        return (
          <Typography sx={{ color: "red" }}>
            {infoBox.msg}
          </Typography>
        );
      case "sucess":
        return (<>
          <Typography>
            اطلاعات سبد خرید:
          </Typography>
          {invoiceContent ? <Invoice invoiceContent={invoiceContent} /> : null}
          <br />
          <Divider>انتخاب درگاه خرید</Divider>
          <br />
          <Box sx={{ textAlign: "center" }}>
            <Button
              className='yn-payment'
              onClick={mellatGateway}
              sx={{ mx: 1 }}
              color="warning"
              variant="contained"
            >
              بانک ملت
              <img src="/img/pic/behpardakht.png" width="30" height="25" />
            </Button>
            {/* <Button
            onClick={mellatGateway}
            sx={{ mx: 1 }}
            color="warning"
            variant="contained"
          >
            بانک ملت
            <img src="/img/pic/behpardakht.png" width="30" height="25" />
          </Button> */}
          </Box>
        </>
        );
      case "selectGateway":
        return (<>
          <Typography>
            اطلاعات سبد خرید:
          </Typography>
          {invoiceContent ? <Invoice invoiceContent={invoiceContent} /> : null}
          <br />
          <Divider>انتخاب درگاه خرید</Divider>
          <br />
          <Button
            sx={{ mx: 0.3 }}
            color="warning"
            variant="contained"
          >
            در حال انتقال به درگاه
          </Button>
          <form style={{ display: "none" }} method="post" name="formBankMellat" id="formBankMellat" action='https://bpm.shaparak.ir/pgwchannel/startpay.mellat'>
            <input type="hidden" value={refId} id="RefId" name="RefId" />
            <input type="submit" />
          </form>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={backdrop}
          >
            <CircularProgress color="inherit" />
          </Backdrop>

        </>

        );
      default:
        return (
          <Typography>
            صبر پیشه کنید
          </Typography>
        );
    }
  }


  React.useEffect(() => {
    handleInfoBox({ state: "wait", msg: "" })
    buyPackage()
  }, [])
  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      {showInfoBox()}
    </Box>
  );
};

